import React, { useState } from 'react'
import { AppMainView, AppView } from '../../../../components/AppView'
import Helmet from 'react-helmet'
import { Alert, Row, Typography, Skeleton } from 'antd-v4'
import AppHeader from '../../../../components/AppView/Header'
import { inject } from 'mobx-react'
import { SmartImage } from '../../../../components/SmartImage'
import { CurrentCompanyStore } from '../../../../stores/CurrentCompanyStore'
import SampleDirectLogo from '../../../../images/sample-direct.png'
import { useScript } from '../../../../utilities/hooks/useScript'
import { WarningFilled } from '@ant-design/icons'

interface IProps {
  currentCompanyStore?: CurrentCompanyStore
}

export const SampleDirect = inject('currentCompanyStore')((props: IProps) => {
  const [showScriptFailedError, setShowScriptFailedError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const company = props.currentCompanyStore?.company
  if (!company?.province) return null
  const SampleDirectMountId = 'sample-direct-embed-script-container'
  useScript('https://app.buddi.io/js/embedded-advertising/b2b.js', {
    mountToElementWithId: SampleDirectMountId,
    attributes: {
      // Buddi uses channelIDs to identify stores and our channelID is 3
      channelID: '3',
      province: company.province,
      companyId: `${company.id}`,
    },
    onError: (event) => {
      setShowScriptFailedError(true)
      console.error(event)
    },
    onLoad: () => setIsLoading(false),
    onReady: () => setIsLoading(true),
  })

  return (
    <AppView column>
      <Helmet>
        <title>Sample Direct</title>
        <meta name='page-loaded' content='true' />
      </Helmet>
      <AppHeader title='Samples'></AppHeader>
      <AppMainView className='background-grey'>
        <Row className='p-3 white-rounded-container'>
          <Row className='d-flex flex-column'>
            <Row className='d-flex mb-2 justify-content-center'>
              <SmartImage width={120} height={120} src={SampleDirectLogo} element='div' />
            </Row>
            <Typography className='text-center'>
              <Typography.Text style={{ fontSize: 24 }}>Sample Direct</Typography.Text>
              <Typography.Paragraph className='mt-2 mb-0'>
                Allowing retailers to order samples directly from brands and LPs, checking new drops
                and samples that are trending
              </Typography.Paragraph>
            </Typography>
          </Row>
        </Row>
        <Row style={{ minHeight: '8rem' }} className='p-3 white-rounded-container'>
          {showScriptFailedError && (
            <Alert
              showIcon
              icon={<WarningFilled />}
              type='error'
              message='A third-party script failed, please try to refresh or try again later.'
            />
          )}
          <Skeleton paragraph={{ rows: 1 }} loading={isLoading && !showScriptFailedError} active />
          <div style={{ display: !isLoading ? 'block' : 'none' }} id={SampleDirectMountId}></div>
        </Row>
      </AppMainView>
    </AppView>
  )
})
